import { useEffect } from 'react';

// Filter helper for Fabian
const useFilterHelper = (vehicleSearchParams: URLSearchParams) => {
  const paramsString = vehicleSearchParams.toString();

  useEffect(() => {
    window.currentSearchFilter = {
      params: paramsString || undefined,
      qf: btoa(paramsString) || undefined,
      url: window.location.href,
      pretty: window.location.pathname.split('/').slice(2)?.join('/') || undefined,
    };
  }, [paramsString]);
};

export default useFilterHelper;
